import PropTypes from 'prop-types';
import React from 'react';

import { ALL_COLUMNS } from '../constants';

const SORT_FIELDS = ALL_COLUMNS.filter((c) => c.sortKey);

// Mobile sort: a native select (finger-friendly) for the field + a direction toggle.
const SortControl = ({ sort, dir, setSort }) => (
  <div className="ab-sortctl">
    <select
      className="ab-sortctl__field"
      value={sort}
      onChange={(e) => setSort(e.target.value, dir)}
      aria-label="Sort by"
    >
      {SORT_FIELDS.map((c) => <option key={c.sortKey} value={c.sortKey}>{c.label}</option>)}
    </select>
    <button
      type="button"
      className="ab-sortctl__dir"
      aria-label={`Sort ${dir === 'asc' ? 'ascending' : 'descending'}`}
      onClick={() => setSort(sort, dir === 'asc' ? 'desc' : 'asc')}
    >
      {dir === 'asc' ? '↑' : '↓'}
    </button>
  </div>
);
SortControl.propTypes = {
  sort: PropTypes.string.isRequired,
  dir: PropTypes.string.isRequired,
  setSort: PropTypes.func.isRequired,
};

export default SortControl;
